<template>
  <div class="duty-type">
    <!-- 操作栏容器 -->
    <div class="duty-info-operation-container">
      <div class="duty-info-search-container">
        <!-- 搜索框 -->
        <search
          class="duty-search"
          placeholder="请输入值日类型"
          @search="dutySearch"
        />
        <el-select
          class="duty-select"
          v-model="dutyAreaVal"
          clearable
          placeholder="请选择范围"
          @change="selectDutyArea"
        >
          <el-option
            v-for="item in dutyAreaList"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>
      </div>
      <div class="duty-info-button-container">
        <!-- 新增 -->
        <button class="button add-duty" @click="addFormShow = true">
          <i class="iconfont icon-addGlade"></i>新增类型
        </button>
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="duty-info-table-container" v-bitmap="checkListGetResult">
      <checkList
        class="duty-list"
        :dutyAreaList="dutyAreaList"
        :isShowList="isShowList"
        :checkList="checkList"
        v-show="total"
      />
    </div>
    <!-- 分页容器 -->
    <div class="duty-info-pagination-catainer">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <!-- 新增 -->
    <addTypeDialog
      :dialogVisible.sync="addFormShow"
      :dutyAreaList="dutyAreaList"
      :isShowList="isShowList"
      v-show="addFormShow"
    />
  </div>
</template>

<script>
import checkList from "./components/check-list/checkList.vue";
import addTypeDialog from "./components/type-add/type-add.vue";
import search from "@/components/search/search.vue";

export default {
  data() {
    return {
      addFormShow: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      checkListGetResult: "nullData",
      checkList: null,
      total: 1,
      dutyAreaList: [], // 值日范围字典列表
      isShowList: [], // 是否展示字典列表
      dutyAreaVal: '',
      dutyTypeName: ''
    };
  },
  components: {
    search,
    checkList,
    addTypeDialog,
  },
  provide() {
    return {
      refresh: this.getDutyTypeList,
    };
  },
  created() {
    this.getDutyTypeList();
    this.getDutyArea();
    this.getIsShow();
  },
  methods: {
    dutySearch(e) {
      this.dutyTypeName = e;
      this.getDutyTypeList();
    },
    selectDutyArea(e) {
      this.dutyAreaVal = e;
      this.getDutyTypeList();
    },
    deleteClick() {},
    getDutyArea() {
      this.get(this.$url.getDictType + "/sc_duty_area").then((res) => {
        // console.log("值日范围:", res);
        this.dutyAreaList = res.data;
      });
    },
    getIsShow() {
      this.get(this.$url.getDictType + "/is_show").then((res) => {
        // console.log("是否展示:", res);
        this.isShowList = res.data;
      });
    },
    getDutyTypeList() {
      let data = {
        schoolId: this.user.schoolId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        typeName: this.dutyTypeName,
        dutyArea: this.dutyAreaVal
      };
      // this.checkListGetResult = "loading";
      this.get(this.$url.selectDutyTypeList, data).then((res) => {
        // console.log("获取学校值日类型==>", res);
        if (res.code != 200) {
          this.checkListGetResult = "error";
          return this.$message.error("获取值日类型失败");
        }
        this.checkList = res.rows;
        this.total = res.total;
        this.total > 0
          ? (this.checkListGetResult = "success")
          : (this.checkListGetResult = "nullData");
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getDutyTypeList();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getDutyTypeList();
    },
  },
};
</script>

<style lang='scss' scoped>
@import "./dutyType.scss";
</style>